module.exports = __webpack_public_path__ + "static/media/gange.7e19a0d5.m4a";